import { Location, LocationType } from '../../../@posturinn/client-react';

// Convert Degress to Radians
function Deg2Rad(deg) {
	return (deg * Math.PI) / 180;
}

function PythagorasEquirectangular(lat1, lon1, lat2, lon2) {
	lat1 = Deg2Rad(lat1);
	lat2 = Deg2Rad(lat2);
	lon1 = Deg2Rad(lon1);
	lon2 = Deg2Rad(lon2);
	const R = 6371; // km
	const x = (lon2 - lon1) * Math.cos((lat1 + lat2) / 2);
	const y = lat2 - lat1;
	const d = Math.sqrt(x * x + y * y) * R;
	return d;
}

export const findClosestLocation = (geolocation: any, locations: Location[], locationType: LocationType) => {
	const items: Location[] = [];
	for (let i = 0; i < locations.length; i++) if (locations[i].locationType === locationType) items.push(locations[i]);

	const { latitude, longitude } = geolocation;
	let minDif = 99999;
	let closest = 0;

	for (let i = 0; i < items.length; ++i) {
		const dif = PythagorasEquirectangular(latitude, longitude, items[i].latitude, items[i].longitude);
		if (dif < minDif) {
			closest = i;
			minDif = dif;
		}
	}

	return items[closest];
};
